'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
require('../../../../typography/ErrorText/ErrorText.js');
require('../../../../typography/LargeDarkText/LargeDarkText.js');
require('../../../../typography/LargeEmphasizedWhiteText/LargeEmphasizedWhiteText.js');
require('../../../../typography/MediumDarkText/MediumDarkText.js');
require('../../../../typography/MediumEmphasizedDarkText/MediumEmphasizedDarkText.js');
require('../../../../typography/MediumText/MediumText.js');
require('../../../../typography/MediumWhiteText/MediumWhiteText.js');
require('../../../../typography/MiniatureLinkText/MiniatureLinkText.js');
var SmallDarkText = require('../../../../typography/SmallDarkText/SmallDarkText.js');
require('../../../../typography/SmallDarkTextHeavy/SmallDarkTextHeavy.js');
require('../../../../typography/SmallDisabledText/SmallDisabledText.js');
require('../../../../typography/SmallEmphasizedDarkText/SmallEmphasizedDarkText.js');
require('../../../../typography/SmallEmphasizedDisabledText/SmallEmphasizedDisabledText.js');
require('../../../../typography/SmallEmphasizedLinkText/SmallEmphasizedLinkText.js');
require('../../../../typography/SmallLinkText/SmallLinkText.js');
require('../../../../typography/SmallTitleText/SmallTitleText.js');
require('../../../../typography/SmallWhiteText/SmallWhiteText.js');
require('../../../../typography/TinyDarkText/TinyDarkText.js');
require('../../../../typography/TinyEmphasizedDarkText/TinyEmphasizedDarkText.js');
require('../../../../typography/TinyLinkText/TinyLinkText.js');
require('../../../../typography/TinyTitleText/TinyTitleText.js');
require('../../../../typography/XXLargeDarkText/XXLargeDarkText.js');
var TextWithTooltip = require('../../../../TextWithTooltip/TextWithTooltip.js');
var styledComponents = require('./styled-components.js');

var TableDataCell = function (props) {
    var _a = props.data, data = _a === void 0 ? '' : _a, tooltip = props.tooltip;
    return (React__default.createElement(styledComponents.PercentCell, { align: 'center' }, tooltip ? (React__default.createElement(TextWithTooltip, { "data-testid": 'table-data-cell-tooltip', tooltipText: React__default.createElement("span", null, tooltip), displayText: React__default.createElement(SmallDarkText, null, data), placement: 'bottom' })) : (React__default.createElement(SmallDarkText, null, data))));
};

module.exports = TableDataCell;
